<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="type" >
        <span slot="label" >
          <a-tooltip>
            类型<template slot="title">1. 海关 2.自定义</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.type"  button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.OrderAddressKeyWordEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="keyword" >
        <span slot="label" >
          <a-tooltip>
            关键词<template slot="title">关键词</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.keyword" type="textarea" :maxLength="255" :placeholder="$t('请输入')+'关键词, 用逗号或顿号隔开'" />
      </a-form-model-item>
      <a-form-model-item prop="message" >
        <span slot="label" >
          <a-tooltip>
            提示语<template slot="title">提示语</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.message" type="textarea" style="height: 100px" :maxLength="255" :placeholder="$t('请输入')+'提示语'" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            备注<template slot="title">备注</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAddressKeywordRestriction, addAddressKeywordRestriction, updateAddressKeywordRestriction } from '@/api/order/addressKeywordRestriction'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        type: 2,

        keyword: null,

        message: null,

        createTime: null,
        localeFieldMap:{},

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        type: [
          { required: true, message: '类型'+this.$t('不能为空'), trigger: 'change' }
        ],
        keyword: [
          { required: true, message: '关键词'+this.$t('不能为空'), trigger: 'blur' }
        ],
        message: [
          { required: true, message: '提示语'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: 2,
        keyword: null,
        message: null,
        createTime: null,
        localeFieldMap:{},
        remark: null
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAddressKeywordRestriction({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateAddressKeywordRestriction(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addAddressKeywordRestriction(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
